import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { FeedbackForm, FeedbackFormApi } from '@fmnts/api/next';
import { catchError, map, of } from 'rxjs';

export interface SupporterFeedbackResolveResult {
  /**
   * Is set, if feedback form is acquired
   */
  feedbackForm?: FeedbackForm;
  /**
   * Is set in case an error occured
   */
  error?: { message: string };
}

export const supporterFeedbackResolver: ResolveFn<
  SupporterFeedbackResolveResult
> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
  inject(FeedbackFormApi)
    .get(route.queryParamMap.get('hash'))
    .pipe(
      map((feedbackForm): SupporterFeedbackResolveResult => ({ feedbackForm })),
      catchError(({ message: error }) =>
        of({ error } as SupporterFeedbackResolveResult),
      ),
    );
